import { render, staticRenderFns } from "./gyms.vue?vue&type=template&id=41ce2240"
import script from "./gyms.vue?vue&type=script&lang=js"
export * from "./gyms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports